import { useIntl } from 'react-intl';
import { Icon } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import { getHeapDataAttribute, HeapAttributes } from '../../../../../utils/heap-data';
import { trackClickWithElementID } from '../../../../../utils/tracking';
import { navigationLinkProps } from '../../../../../types';
import styles from './NavLink.module.scss';

const handlePointerDown = (e: React.PointerEvent<HTMLAnchorElement>, path: string) => {
    /**
     * Prevent any additional behavior from pointer down and just change the location path
     */
    e.preventDefault();
    e.stopPropagation();

    if (typeof window !== 'undefined') {
        (window as Window).location = path;
    }
};

const isSignuporloginUrl = (heapIdentifier: string) => {
    return ['signup', 'login'].includes(heapIdentifier);
};

const METRIC_NAME_CLICK = 'GlobalNav - Logged out - Click - NavLink (Web)';

export const NavLink = ({
    path,
    heapIdentifier,
    translatedText,
    textColor,
    iconType,
    iconPosition,
    className,
}: navigationLinkProps) => {
    const navLinkClass = classNames(styles.main, className);
    const iconPositionClass = iconPosition === 'right' ? styles.iconRight : '';
    const { Teams, Features, Components, Actions } = HeapAttributes;
    const { formatMessage } = useIntl();
    return (
        <a
            className={navLinkClass}
            href={path}
            onPointerDown={(e) => {
                trackClickWithElementID(METRIC_NAME_CLICK, heapIdentifier);
                return handlePointerDown(e, path);
            }}
            data-testid="navLink"
            aria-label={formatMessage(translatedText)}
            data-heap-id={getHeapDataAttribute({
                team: Teams.SEO,
                feature: Features.GlobalNav,
                component: Components.Link,
                name: heapIdentifier.replaceAll(' ', '-').toLowerCase(),
                action: Actions.Click,
            })}
            {...(isSignuporloginUrl(heapIdentifier) && {
                rel: 'nofollow',
            })}
        >
            {!!iconType && (
                <span data-testid="navLink-icon" className={iconPositionClass}>
                    <Icon>
                        <>{iconType}</>
                    </Icon>
                </span>
            )}
            <span style={{ color: textColor }} aria-label={formatMessage(translatedText)}>
                {formatMessage(translatedText)}
            </span>
        </a>
    );
};
